// colors.js
export const colors = {
    primary: 'rgba(84, 128, 84, 1)',
    secondary: 'rgb(72, 147, 56)',
    tertiary: 'rgba(205, 236, 198, 1)',
    kcalCol: '#439DEE',
    proteinCol: '#64CC64',
    carbsCol: '#F5E268',
    fatCol: '#F16666',
    redPink: '#f08080',
};
